import { render, staticRenderFns } from "./TabHistoryLogView.vue?vue&type=template&id=4a510cfd&scoped=true&lang=pug"
import script from "./TabHistoryLogView.vue?vue&type=script&lang=js"
export * from "./TabHistoryLogView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a510cfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a510cfd')) {
      api.createRecord('4a510cfd', component.options)
    } else {
      api.reload('4a510cfd', component.options)
    }
    module.hot.accept("./TabHistoryLogView.vue?vue&type=template&id=4a510cfd&scoped=true&lang=pug", function () {
      api.rerender('4a510cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/TabHistoryLogView.vue"
export default component.exports